document.addEventListener("DOMContentLoaded", () => {
  // Check if the swiper element exists on this page
  const swiperElement = document.querySelector(".baSwiper");
  if (!swiperElement) return;

  // Check if Swiper library is loaded
  if (typeof Swiper === 'undefined') {
    // Load Swiper library dynamically if it's not already loaded
    const script = document.createElement('script');
    script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    script.onload = initializeSwiper;
    document.body.appendChild(script);
  } else {
    // If Swiper is already loaded, initialize immediately
    initializeSwiper();
  }

  function initializeSwiper() {
    new Swiper(".baSwiper", {
      loop: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: true
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    });
  }
});